import muliplierBar from '../../../../asset/images/multiplierReel/multipleBar.png'
import multiplierSelectFrame from '../../../../asset/images/multiplierReel/selectFrame.png'
import multiplierSelectBg from '../../../../asset/images/multiplierReel/selectGround.png'
import mainGametable from '../../../../asset/images/background/TABLE_Main.png'
import freeGameTable from '../../../../asset/images/background/TABLE_FreeGame.png'

import voucher_bg from '../../../../asset/images/voucher/voucher_bg.png'
import voucher_gift from '../../../../asset/images/voucher/voucher_gift.png'
import voucher_halo from '../../../../asset/images/voucher/voucher_halo.png'
import voucher_play_later_click from '../../../../asset/images/voucher/voucher_play_later_click.png'
import voucher_play_later_hover from '../../../../asset/images/voucher/voucher_play_later_hover.png'
import voucher_play_later_normal from '../../../../asset/images/voucher/voucher_play_later_normal.png'
import voucher_play_later_unable from '../../../../asset/images/voucher/voucher_play_later_unable.png'
import voucher_play_now_click from '../../../../asset/images/voucher/voucher_play_now_click.png'
import voucher_play_now_hover from '../../../../asset/images/voucher/voucher_play_now_hover.png'
import voucher_play_now_normal from '../../../../asset/images/voucher/voucher_play_now_normal.png'
import voucher_play_now_unable from '../../../../asset/images/voucher/voucher_play_now_unable.png'
import voucher_Popup from '../../../../asset/images/voucher/voucher_Pop-up.png'
import voucher_Time_left from '../../../../asset/images/voucher/voucher_Time_left.png'
import voucher_Total_Win from '../../../../asset/images/voucher/voucher_Total_Win.png'
import voucher_History from '../../../../asset/images/voucher/voucher_History.png'

import close_normal from '../../../../asset/images/menu/close_normal.png'
import close_hover from '../../../../asset/images/menu/close_hover.png'
import close_click from '../../../../asset/images/menu/close_click.png'

export const geMultiplierReelDatas = () => {
  const MultiplierReelDatas = [
    { alias: 'muliplierBar', src: muliplierBar, loadParser: 'loadTextures' },
    { alias: 'multiplierSelectFrame', src: multiplierSelectFrame, loadParser: 'loadTextures' },
    { alias: 'multiplierSelectBg', src: multiplierSelectBg, loadParser: 'loadTextures' },
  ]
  return MultiplierReelDatas
}

export const getTableBgDatas = () => {
  const tableBgDatas = [
    { alias: 'mainGametable', src: mainGametable, loadParser: 'loadTextures' },
    { alias: 'freeGameTable', src: freeGameTable, loadParser: 'loadTextures' },
  ]
  return tableBgDatas
}

export const getVoucherImageDatas = () => {
  const voucherImageDatas = [
    { alias: 'voucher_bg', src: voucher_bg, loadParser: 'loadTextures' },
    { alias: 'voucher_gift', src: voucher_gift, loadParser: 'loadTextures' },
    { alias: 'voucher_halo', src: voucher_halo, loadParser: 'loadTextures' },
    { alias: 'voucher_play_later_click', src: voucher_play_later_click, loadParser: 'loadTextures' },
    { alias: 'voucher_play_later_hover', src: voucher_play_later_hover, loadParser: 'loadTextures' },
    { alias: 'voucher_play_later_normal', src: voucher_play_later_normal, loadParser: 'loadTextures' },
    { alias: 'voucher_play_later_unable', src: voucher_play_later_unable, loadParser: 'loadTextures' },
    { alias: 'voucher_play_now_click', src: voucher_play_now_click, loadParser: 'loadTextures' },
    { alias: 'voucher_play_now_hover', src: voucher_play_now_hover, loadParser: 'loadTextures' },
    { alias: 'voucher_play_now_normal', src: voucher_play_now_normal, loadParser: 'loadTextures' },
    { alias: 'voucher_play_now_unable', src: voucher_play_now_unable, loadParser: 'loadTextures' },
    { alias: 'voucher_Pop-up', src: voucher_Popup, loadParser: 'loadTextures' },
    { alias: 'voucher_Time_left', src: voucher_Time_left, loadParser: 'loadTextures' },
    { alias: 'voucher_Total_Win', src: voucher_Total_Win, loadParser: 'loadTextures' },
    { alias: 'voucher_History', src: voucher_History, loadParser: 'loadTextures' },
  ]
  return voucherImageDatas
}

export const getBetHistoryImageDatas = () => {
  const betHistoryImageDatas = [
    { alias: 'close_normal', src: close_normal, loadParser: 'loadTextures' },
    { alias: 'close_hover', src: close_hover, loadParser: 'loadTextures' },
    { alias: 'close_click', src: close_click, loadParser: 'loadTextures' },
  ]
  return betHistoryImageDatas
}
